module.exports = __webpack_public_path__ + "static/media/test3_2.a9796b66.png";